import { render, staticRenderFns } from "./TradableBonusHistory.vue?vue&type=template&id=4b608060"
import script from "./TradableBonusHistory.vue?vue&type=script&lang=js"
export * from "./TradableBonusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports